export const MAIN_NAV_ITEMS = [
  { to: '/jobs', tooltip: 'Trouvez un job dans le secteur public', label: 'Les jobs', shortLabel: 'Jobs' },
  { to: 'https://media.profilpublic.fr/je-minspire', tooltip: 'Explorez le secteur public', label: 'Le média', shortLabel: 'Média', external: true },
  { to: '/nos-etudes', tooltip: 'Découvrez nos publications', label: 'Nos études', shortLabel: 'Études' },
]
